import React from "react";

export function DashedVerticalLineIcon() {
  return (
    <>
      <svg
        width="1"
        height="24"
        viewBox="0 0 1 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <line
          x1="0.5"
          x2="0.5"
          y2="24"
          stroke="#848586"
          strokeDasharray="2 2"
        />
      </svg>
    </>
  );
}
